/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 */

import { aiAssistantSearchFilters } from '@zcode/nr/es/shared/api'
import { logger } from '@zcode/utils'
import { DEFAULT_FILTERS } from '../../../constants'
import { getReduxFriendlyFilters } from '../../../helpers/filters/getReduxFriendlyFilters'
import type { Dispatch } from '../../types'
import { handleFilterChange } from './handleFilterChange'

export const getAIAssistantSearchFilters = (searchQuery: string) => async (dispatch: Dispatch) => {
  try {
    const aiSearchFilters = await aiAssistantSearchFilters.query({
      q: searchQuery,
    })

    if (!aiSearchFilters || Object.keys(aiSearchFilters).length === 0) {
      return
    }

    const defaultFilters = { ...DEFAULT_FILTERS }
    const mappedAIFilters = getReduxFriendlyFilters(aiSearchFilters)

    const newFilters = { ...defaultFilters, ...mappedAIFilters }
    dispatch(handleFilterChange(newFilters))
    return aiSearchFilters
  } catch (error) {
    logger.error('Error loading Ask Zoe query', error)
    return
  }
}
